import { GenericService } from './generic.service';
export class DocumentTemplateService extends GenericService {
    constructor() {
        super('v1/document-templates');
    }
}
